import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {
  @Input()
  public rowData: any;

  public isViewEnabled: boolean;
  public isEditEnabled: boolean;

  @Output()
  public view: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public edit: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
    const permissions = this.rowData.permissionsDTO;
    this.isEditEnabled = permissions && (permissions.canEditInformation || permissions.isOwner);
    this.isViewEnabled = permissions && (permissions.canViewInformation || permissions.isOwner);
  }

  public viewAction(): void {
    this.view.emit(this.rowData);
  }

  public editAction(): void {
    this.edit.emit(this.rowData);
  }

  public inviteAction(): void {
    console.log('inviteAction');
    console.log(this.rowData);
    this.router.navigateByUrl('/utilizator/persoana-juridica/conturi', {
      state: {companyName: this.rowData.name, companyCode: this.rowData.cui}
    });
  }
}
